var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_147_1",
    "data-name": "Component 147 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 24,
    height: 24,
    rx: 2,
    fill: "#e6e6e8",
    opacity: 0
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "U",
    transform: "translate(6 19)",
    fill: "#0d0d0d",
    fontSize: 16,
    fontFamily: "Verdana-Bold, Verdana",
    fontWeight: 700,
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineEditorIcon);
export default __webpack_public_path__ + "static/media/underline-editor-icon.c502d252dbbf33ee2d9dd95c44fe32dd.svg";
export { ForwardRef as ReactComponent };